const Content = {
  'menu_items': [
    {
      'name': 'Thinking',
      'slug': 'thinking',
      'href': '/'
    },
    {
      'name': 'Services',
      'slug': 'services',
      'href': '/services'
    },
    {
      'name': 'Expertise',
      'slug': 'expertise',
      'href': '/expertise'
    },
    {
      'name': 'People',
      'slug': 'people',
      'href': '/people'
    },
    {
      'name': 'Network',
      'slug': 'network',
      'href': '/network'
    },
    {
      'name': 'News',
      'slug': 'news',
      'href': '/news'
    }
  ]
};

export { Content };
